// Menu Variables
const headerNav = document.querySelector('.header__navigation');
const megaMenuItems = document.querySelectorAll('.has-mega-menu > a');
const regularItems = document.querySelectorAll('.main-nav__menu li:not(.has-mega-menu)');

const hamburgerBtn = document.querySelector('.main-nav__trigger');
const megamenu = document.querySelector('.megamenu');
const backdrop = document.querySelector('.megamenu__backdrop');

const megaMenuTriggers = document.querySelectorAll('.megamenu__trigger');
const megaMenuSubTriggers = document.querySelectorAll('.megamenu__subtrigger');
const megaMenuBack = document.querySelectorAll('.megamenu__back');

function showMobileMenu() {
  megamenu.classList.add('is-visible');
  backdrop.classList.add('is-visible');
  toggleScroll('disable');
}

function hideMobileMenu() {
  megamenu.classList.remove('is-visible');
  backdrop.classList.remove('is-visible');
  toggleScroll('enable');
}

function slideNextPanel() {
  event.preventDefault();
  const thisPanel = event.target.nextElementSibling;
  thisPanel.classList.add('is-visible');
  return false;
}

function slideBackPanel() {
  event.preventDefault();
  const thisPanel = event.target.parentElement;
  console.log(thisPanel);
  thisPanel.classList.remove('is-visible');
  return false;
}

function hideMegaMenu() {
  const curPanel = document.querySelector('.megamenu__container.is-open');
  const curLink = document.querySelector('.main-nav__menu a.is-active');
  if (curPanel) {
    curPanel.classList.remove('is-open');
  }
  if (curLink) {
    curLink.classList.remove('is-active');
  }
}

function showMegaMenu() {
  const thisRel = event.target.getAttribute('rel');
  const thisPanel = document.getElementById(thisRel);
  const curPanel = document.querySelector('.megamenu__container.is-open');

  hideMegaMenu();

  thisPanel.classList.add('is-open');
  event.target.classList.add('is-active');
}

// Add Events Listener
if (megaMenuItems) {
  megaMenuItems.forEach(item => item.addEventListener('mouseenter', showMegaMenu));
}

if(hamburgerBtn) {
  hamburgerBtn.addEventListener('click', showMobileMenu);
}

if(backdrop) {
  backdrop.addEventListener('click', hideMobileMenu);
}


if(megaMenuTriggers) {
  megaMenuTriggers.forEach(trigger => trigger.addEventListener('click', slideNextPanel));
}

if(megaMenuSubTriggers) {
  megaMenuSubTriggers.forEach(trigger => trigger.addEventListener('click', slideNextPanel));
}

if(megaMenuBack) {
  megaMenuBack.forEach(trigger => trigger.addEventListener('click', slideBackPanel));
}

if(headerNav) {
  headerNav.addEventListener('mouseleave', ()=>{
    headerNav.classList.remove('is-hover');
    hideMegaMenu();
  });
  headerNav.addEventListener('mouseenter', ()=> {
    headerNav.classList.add('is-hover');
  });
}


if (regularItems) {
  regularItems.forEach(item => item.addEventListener('mouseenter', hideMegaMenu));
}



// WEBPACK FOOTER //
// ./scripts/util/megaMenu.js